import { AccountsMasterActionList, AccountsMasterType } from "../actions/accountsMasterActions"
import { Action } from "../actions/types"

const initialValue: Array<AccountsMasterType> = []

const accountsMasterReducer = (state: Array<AccountsMasterType> = initialValue, action: Action) => {
    switch (action.type) {

        case AccountsMasterActionList.ADD_ACCOUNTS_MASTER:
            return [
                ...state,
                action.data,
            ]

        case AccountsMasterActionList.UPDATE_ACCOUNTS_MASTER:
            const updated = [...state].slice()
            const index = updated.findIndex(u => u.id === action.data.id)

            if (index > -1) {
                updated[index] = {
                    ...action.data
                }
            }

            return updated

        case AccountsMasterActionList.FETCH_ACCOUNTS_MASTER:
            return action.data

        case AccountsMasterActionList.DELETE_ACCOUNTS_MASTER:
            return state.filter(s => s.id !== action.data)

        default:
            return state
    }
}

export default accountsMasterReducer